// FilePaths situados no back-end - br.com.elotech.adm.arquivo.domain.enums.FilePathEnum
export enum FilePathEnum {
  COMPRAS_ATOS = 1,
  COMPRAS_ANEXO = 2,
  COMPRAS_ADITIVO = 3,
  COMPRAS_CONTRATO = 4,
  COMPRAS_TEMPLATE_CONTRATO = 5,
  COMPRAS_COTACAO = 6,
  COMPRAS_LICITACAO = 7,
  COMPRAS_TEMPLATE_LICITACAO = 8,
  COMPRAS_PEDIDO_COMPRAS = 9,
  COMPRAS_RECURSO = 10,
  COMPRAS_SOLICITACAO = 11,
  COMPRAS_LICITACAO_PARECER = 12,
  COMPRAS_HOMOLOGACAO = 13,
  COMPRAS_LICITACAO_PUBLICACAO = 14,
  COMPRAS_ADJUDICACAO = 15,
  COMPRAS_TEMPLATE_PROCESSO_ADM = 16,
  COMPRAS_CERTIFICADO_REGISTRO_CADASTRAL = 17,
  COMPRAS_LICITACAO_PARTICIPANTE = 18,
  COMPRAS_PLANO_CONTRATACAO_ANUAL = 19,
  COMPRAS_LICITACAO_PARTICIPANTE_DOCUMENTACOES = 20,
  COMPRAS_AUTORIZACAO = 21,
  COMPRAS_REQUISICAO_EXTRA = 22,
  COMPRAS_CONTRATO_SUSPENSAO = 23,
  COMPRAS_CONTRATO_EVENTO = 24,
  OBRAS_TERMO_ANDAMENTO = 25,
  OBRAS_INTERVENCAO = 26,
  OBRAS_ACOMPANHAMENTO = 27,
  OBRAS_OCORRENCIA = 28,
  OBRAS_PLANILHA_ORCAMENTO = 29,
  OBRAS_RESPONSABILIDADE_TECNICA = 30,
  OBRAS_ORIGEM_RECURSO = 31,
  OBRAS_INTERVENCAO_MEDICAO = 32,
  OBRAS_LICENSA = 33,
  PATRIMONIO_BEM = 51,
  PATRIMONIO_SEGURO = 52,
  PATRIMONIO_TRANSFERENCIA = 53,
  PATRIMONIO_TERMO = 54,
  PATRIMONIO_MOVIMENTO = 55,
  PATRIMONIO_MANUTENCAO = 56,
  PATRIMONIO_MOVIMENTACAO_CADASTRAL = 57,
  GERAIS = 99,
  CONTROLEINTERNO_MANUAL = 70,
  CONTROLEINTERNO_ETAPA_EXECUCAO = 71,
  CONTROLEINTERNO_PERGUNTA = 72,
  CONTROLEINTERNO_TEMPLATES = 73,
  LEGISLACOES_ESPECIFICAS = 74,
  AMOSTRAS = 105,
  COMISSAO = 106,
  CONTRATO_PUBLICACOES = 107,
  COMPRAS_LICITACAO_EVENTO = 108,
  RESPONSAVEL_CONTRATO = 109,
  COMPRAS_SEGURO_GARANTIA = 110,
  COMPRAS_CONTRATO_FISCALIZACAO = 113,
  COMPRAS_LISTA_COMPRA = 115
}
